import { useState } from "react";
import TimesheetViewSheet from "@/modules/work/jobs/timesheet/history/components/timesheet-view-sheet";
import { EmployeeCell } from "components/cell/employee/cell";
import { CURRENT_MONTH_END_DATE, CURRENT_MONTH_START_DATE } from "@/lib/utils";
import { DateCell } from "@/components/date/cell";
import { HoursCell } from "@/components/hours/cell";
import { TagCell } from "@/modules/work/jobs/timesheet/tags/_cell";
import MyTeamTimesheetFilters from "./filters";
import { List } from "components";

export default function MyTeamTimesheetTable() {
    const [selectedTimesheetId, setSelectedTimesheetId] = useState(null);

    const FIELDS = [
        "id",
        "date",
        "employee.avatar",
        "employee.first_name",
        "employee.last_name",
        "project",
        "project.name",
        "job",
        "job.name",
        "tag.label",
        "tag.color",
        "logged_hours",
        "reviewer.avatar",
        "reviewer.first_name",
        "reviewer.last_name",
        "approved_hours",
        "unapproved_hours",
    ]

    const COLUMNS = [
        {
            id: "date",
            header: "Date",
            accessorKey: "date",
            sortable: true,
            cell: DateCell,
        },
        {
            id: "employee",
            header: "Employee",
            accessorKey: "employee",
            cell: EmployeeCell,
        },
        {
            id: "project",
            header: "Project",
            accessorKey: "project.name",
            sortable: true,
        },
        {
            id: "job",
            header: "Job",
            accessorKey: "job.name",
            sortable: true,
        },
        {
            id: "tag",
            header: "Tag",
            accessorKey: "tag",
            sortable: true,
            cell: TagCell,
        },
        {
            id: "logged_hours",
            header: "Logged",
            accessorKey: "logged_hours",
            sortable: true,
            cell: HoursCell,
        },
        {
            id: "reviewer",
            header: "Reviewer",
            accessorKey: "reviewer",
            cell: EmployeeCell,
        },
        {
            id: "approved_hours",
            header: "Approved",
            accessorKey: "approved_hours",
            sortable: true,
            cell: HoursCell,
        },
        {
            id: "unapproved_hours",
            header: "Unapproved",
            accessorKey: "unapproved_hours",
            sortable: true,
            cell: HoursCell,
        },
    ];

    const defaultFilters = {
        date: {
            _gte: CURRENT_MONTH_START_DATE,
            _lte: CURRENT_MONTH_END_DATE,
        },
        logged_hours: {
            _gt: 0,
        },
    }

    return (
        <div className="flex-1">
            <List
                title="Timesheet"
                storageKey="timesheet-my-team"
                endPoint="timesheet"
                showSearch={false}
                perPage={10}
                meta={{
                    fields: FIELDS,
                }}
                columns={COLUMNS}
                filters={defaultFilters}
                teleportFilters={true}
                renderFilters={MyTeamTimesheetFilters}
                onClick={(item) => setSelectedTimesheetId(item.id)}
            />
            <TimesheetViewSheet
                timesheetId={selectedTimesheetId}
                open={!!selectedTimesheetId}
                onOpenChange={(open) => {
                    if (!open) setSelectedTimesheetId(null);
                }}
                showEmployee={true}
            />
        </div>
    );
}
